import { useState } from "react";
import styled from "styled-components";
import { Popover } from "antd";
import { removeOnClickBubble } from "utils";
import Cross from "../../../assets/img/icons/cross_grey.svg";
import Search from "../../../assets/img/icons/ArticlePopover/lowerList/search.svg";
import List from "../../../assets/img/icons/ArticlePopover/lowerList/list.svg";
import Frame from "../../../assets/img/icons/ArticlePopover/lowerList/frame.svg";
import Profile from "../../../assets/img/icons/ArticlePopover/lowerList/profile.svg";
import Delete from "../../../assets/img/icons/ArticlePopover/lowerList/Delete.svg";
import Send from "../../../assets/img/icons/Send (5).svg";

import { useHistory } from "react-router";
import CreateAsset from "modules/Campaigns/CampaignAssets/Components/CreateAsset";
import { ASSET_TYPE } from "./../../../constants/index";

const PopupTitle = ({ campaignId, assetId, versionId, assetType }: any) => {
  const history = useHistory();
  const onHandleEditDraft = () => {
    if (assetType === ASSET_TYPE.CUSTOM) {
      if (campaignId) {
        history.push(`/design?campaign_id=${campaignId}&asset_id=${assetId}&version_id=${versionId}`);
      } else {
        history.push(`/design?asset_id=${assetId}&version_id=${versionId}`);
      }
    } else {
      if (campaignId) {
        history.push(`/campaigns/editionedit?campaign_id=${campaignId}&email_id=${assetId}`);
      } else {
        history.push(`/campaigns/editionedit?email_id=${assetId}`);
      }
    }
  };
  return (
    <BlogMenuStylingGreen>
      <div className="BlogItemDropdown">
        <ul>
          <li className="d-flex align-items-center" onClick={onHandleEditDraft}>
            <strong>Edit Draft</strong>
          </li>
          {/* <li
            className="d-flex align-items-center"
            onClick={(e) => {
              removeOnClickBubble(e);
            }}
          >
            {/* <CreateAsset campaignId={campaignId} dropDownWidth="w-100"> */}
          {/* <strong> Create New Draft in Asset</strong> */}
          {/* </CreateAsset> */}
          {/* </li> */}
        </ul>
      </div>
    </BlogMenuStylingGreen>
  );
};

const Content = ({
  id,
  data,
  isFav,
  isCurated,
  campaignId,
  index,
  deleteHandler,
  assetId,
  assetIndex,
  assetDeleteHandler,
  assetCount,
  hide,
  assetType,
  versionId,
}: any) => {
  const history = useHistory();
  const onSmartSourceClick = (e: any) => {
    removeOnClickBubble(e);
    history.push(`/campaigns/content/asset/source?campaign_id=${campaignId}&asset_id=${assetId}`);
  };
  const onContactsClick = (e: any) => {
    removeOnClickBubble(e);
    history.push(`/campaigns/content/asset/audience?campaign_id=${campaignId}&asset_id=${assetId}`);
  };
  const onDraftsClick = (e: any) => {
    removeOnClickBubble(e);
    history.push(`/campaigns/content/asset?campaign_id=${campaignId}&asset_id=${assetId}`);
  };
  const onSentClick = (e: any) => {
    removeOnClickBubble(e);
    history.push(`/campaigns/content/asset/sent?campaign_id=${campaignId}&asset_id=${assetId}`);
  };

  return (
    <BlogMenuStyling>
      <div className="BlogItemDropdown">
        <ul>
          {assetType === ASSET_TYPE.HYBRID && (
            <li
              onClick={(e) => {
                hide();
                removeOnClickBubble(e);
                deleteHandler(index, versionId, assetId);
              }}
              className="d-flex align-items-center"
            >
              <img className="margin-right-sm" src={Delete} alt="icon" />
              <strong> Delete Draft</strong>
            </li>
          )}
        </ul>
      </div>
    </BlogMenuStyling>
  );
};

const DraftMenuPopup = (props: any) => {
  const [visible, setVisible] = useState(false);
  const {
    id,
    data,
    isFav,
    isCurated,
    campaignId,
    index,
    deleteHandler,
    assetId,
    assetIndex,
    assetDeleteHandler,
    assetCount,
    versionId,
    assetType,
  } = props;
  const hide = () => {
    setVisible(false);
  };

  const handleVisibleChange = (visible: any) => {
    setVisible(visible);
  };

  return (
    <Popover
      overlayInnerStyle={{ borderRadius: 10 }}
      overlayClassName="BlogPopover popover-radius "
      placement="leftTop"
      visible={visible}
      // title={popupTitle(data)}
      title={
        <PopupTitle campaignId={props.campaignId} assetId={assetId} versionId={versionId} assetType={assetType} />
      }
      content={
        <Content
          versionId={versionId}
          id={id}
          data={data}
          isFav={isFav}
          isCurated={isCurated}
          campaignId={campaignId}
          index={index}
          deleteHandler={deleteHandler}
          assetId={assetId}
          assetIndex={assetIndex}
          assetDeleteHandler={assetDeleteHandler}
          assetCount={assetCount}
          hide={hide}
          assetType={assetType}
        />
      }
      destroyTooltipOnHide={true}
      trigger="click"
      onVisibleChange={handleVisibleChange}
    >
      <div
        onClick={(e: any) => {
          removeOnClickBubble(e);
        }}
      >
        {props.children}
      </div>
    </Popover>
  );
};

const BlogMenuStylingGreen = styled.div`
  ul li {
    font-family: "roboto_regular", sans-serif;
    font-size: 14px;
    color: #27ce0a;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .opc-5 {
    opacity: 0.5;
  }
`;
const BlogMenuStyling = styled.div`
  ul li {
    font-family: "roboto_regular", sans-serif;
    font-size: 14px;
    padding-top: 5px;
    padding-bottom: 5px;
  }
`;

export default DraftMenuPopup;
